import { Action } from '@ngrx/store';
import { ErrorModel } from '@awp/core/utils';
import { SelectedCard, Card } from '../card.model';
import { ApiInsuranceType } from '@awp/quote/models';

export enum ActionTypes {
  BIN_SEARCH = '[Card Check] Bin Search',
  BIN_SEARCH_SUCCESS = '[Card Check] Bin Search Success',
  BIN_SEARCH_NOT_FOUND = '[Card Check] Bin Search Not Found',
  BIN_SEARCH_FAILURE = '[Card Check] Bin Search Failure',
  BIN_RESET = '[Card Check] Reset Search',
  SELECT_CARD_TYPE = '[Card Check] Select Card Type',
  SELECT_CARD_TYPE_FAILURE = '[Card Check] Select Card Type Failure',
  ALTERNATIVE_BIN = '[Card Check] Alternative Bin',
}

export class SelectCardTypeAction implements Action {
  readonly type = ActionTypes.SELECT_CARD_TYPE;
  constructor(public payload: { card: SelectedCard, insuranceType: ApiInsuranceType }) { }
}

export class SelectCardTypeFailureAction implements Action {
  readonly type = ActionTypes.SELECT_CARD_TYPE_FAILURE;
  readonly error = {
    code: 'PLAN_NOT_FOUND'
  }
  constructor(public insuranceType: ApiInsuranceType) { 
    if(insuranceType ==  ApiInsuranceType.TravelInsurance)
      this.error.code = 'PLAN_NOT_FOUND';
    else
      this.error.code = 'OTHER_INSURANCES_PLAN_NOT_FOUND'
  }
}

export class BinSearchAction implements Action {
  readonly type = ActionTypes.BIN_SEARCH;
  constructor(public payload: string, public insuranceType: ApiInsuranceType) { }
}

export class BinSearchSuccessAction implements Action {
  readonly type = ActionTypes.BIN_SEARCH_SUCCESS;
  constructor(public payload: Card[]) { }
}

export class BinSearchNotFoundAction implements Action {
  readonly type = ActionTypes.BIN_SEARCH_NOT_FOUND;
}

export class BinSearchFailureAction implements Action {
  readonly type = ActionTypes.BIN_SEARCH_FAILURE;
  constructor(public error: ErrorModel) { }
}

export class ResetBinSearch implements Action {
  readonly type = ActionTypes.BIN_RESET;
}

export class AlternativeBinAction implements Action {
  readonly type = ActionTypes.ALTERNATIVE_BIN;
}

export type Actions = SelectCardTypeAction
  | SelectCardTypeFailureAction
  | BinSearchAction
  | BinSearchSuccessAction
  | BinSearchFailureAction
  | BinSearchNotFoundAction
  | ResetBinSearch
  | AlternativeBinAction;
